import React, { useState, useEffect } from 'react';
import "./SongBox.css";
import SongImage from "./SongImage.js";
import SongBoxCountDown from "./SongBoxCountDown.js";
import SpotifyJam from "../../SpotifyJam";
import { useStateValue } from "../../StateProvider";

function SongBox( {TrackForBox, spotify} ) {
    const [{playBlocker, token, songsListenedTo, songsRated, songToPlay, trackInfoCache, showRestartButton }, dispatch] = useStateValue();

    // Debug logging for track synchronization
    console.log("🎵 SongBox render:", {
        trackId: TrackForBox.trackid,
        songName: TrackForBox.songName,
        currentSongToPlay: songToPlay,
        isThisSongPlaying: songToPlay === TrackForBox.trackid
    });

//INITIAL VALUE COUNTDOWN ZEIGEN
    const [showCounter, setShowCounter] = useState(
      //inital value
        0
  ); //hook example

//TRTACKINFO ZUORDENBAR MACHEN
  const [trackInfo, setTrackInfo] = useState(
    //inital value
{
  album:  {
    "name" : "Can't Stop Raving",
  "id" : "67EEM8KMmXq8qxQXdRpmXe"
  },
  artists: [
    {name: "Dune"},
    {artistid: "4u78tFtzvcrrs8kzkXsW4r"}
  ],
id: "5Yf5TUA0ROqVoopGlSqzYM", // puremia
  name: "Can't Stop Raving (Video Mix)",
  popularity: 54,
  tracknumber: 1,
  uri: "spotify:track:4Q7fEjeCZgU8oxjbLWrm7L"
  }
); //hook example

useEffect(() => {
    // Check if track info is already cached
    if (trackInfoCache[TrackForBox.trackid]) {
        // Use cached data
        setTrackInfo(trackInfoCache[TrackForBox.trackid]);
    } else {
        // GET TRACK INFO BASED ON TRACK ID only if not cached
        SpotifyJam.getTrackInfo(TrackForBox.trackid, token).then((response) => {
            setTrackInfo(response);

            // Cache the response to avoid future API calls
            dispatch({
                type: "SET_TRACKINFO",
                trackId: TrackForBox.trackid,
                trackInfo: response,
            });
        });
    }
  }, [TrackForBox.trackid, token, trackInfoCache, dispatch]);

//PLAY SONG NEU
function playSong()
{
  console.log("🎵 SongBox playSong clicked for track:", TrackForBox.trackid);
  console.log("🎵 SongBox: Current songToPlay state:", songToPlay);
  console.log("🎵 SongBox: Full TrackForBox data:", TrackForBox);
  console.log("🎵 SongBox: trackInfo loaded:", trackInfo);
  console.log("🎵 SongBox: showRestartButton:", showRestartButton);

  // Save currently playing song to localStorage so it persists across page reloads
  try {
    const currentlyPlayingSong = {
      ...TrackForBox,
      savedAt: Date.now() // timestamp to detect stale entries
    };
    localStorage.setItem('currentlyPlayingSong', JSON.stringify(currentlyPlayingSong));
    console.log("💾 Saved currently playing song to localStorage:", TrackForBox.trackid);
  } catch (e) {
    console.error("Failed to save currently playing song to localStorage:", e);
  }

  // If this is a restart (same song) AND showRestartButton is true,
  // it's likely a reconnect after reload - just trigger play directly
  if (songToPlay === TrackForBox.trackid && showRestartButton) {
    console.log("🔄 Reconnecting to same song (post-reload), triggering play directly");
    // Clear restart button first
    dispatch({
      type: "SET_SHOWRESTARTBUTTON",
      showRestartButton: false,
    });
    // Trigger play from user click immediately
    dispatch({
      type: "SET_TRIGGERPLAYFROMCLICK",
      triggerPlayFromClick: true,
    });
  }
  // If this is a restart (same song) but NOT from reload, reset to "0" first to trigger useEffect
  else if (songToPlay === TrackForBox.trackid) {
    console.log("🔄 Restarting same song, resetting first");
    dispatch({
      type: "SET_SONGTOPLAY",
      songToPlay: "0",
    });
    // Small delay to ensure state updates before setting the track again
    // Use closure to capture the correct track ID
    const trackIdToPlay = TrackForBox.trackid;
    setTimeout(() => {
      console.log("🔄 Setting track after delay:", trackIdToPlay);
      dispatch({
        type: "SET_SONGTOPLAY",
        songToPlay: trackIdToPlay,
      });
      // Trigger play from user click
      dispatch({
        type: "SET_TRIGGERPLAYFROMCLICK",
        triggerPlayFromClick: true,
      });
      console.log("🎵 SongBox: Dispatched SET_SONGTOPLAY with:", trackIdToPlay);
    }, 50);
  } else {
    // New song, set directly
    dispatch({
      type: "SET_SONGTOPLAY",
      songToPlay: TrackForBox.trackid,
    });
    // Trigger play from user click (maintains iOS user interaction chain)
    dispatch({
      type: "SET_TRIGGERPLAYFROMCLICK",
      triggerPlayFromClick: true,
    });
    console.log("🎵 SongBox: Dispatched SET_SONGTOPLAY with:", TrackForBox.trackid);
  }

  dispatch({
    type: "SET_SHOWSPOTIFYPLAYER",
    showSpotifyPlayer: 1,
  });
  console.log("🎵 SongBox: Dispatched SET_SHOWSPOTIFYPLAYER");

dispatch({
  type: "SET_PLAYBLOCKER",
  playBlocker: 1,
});

//INitialize play button zeigen
dispatch({
  type: "SET_SHOWINITIALIZEPLAYERBUTTON",
  showInitializePlayerButton: 1,
   });

//zeigt countdown? nach play
setShowCounter( 1 );
};

  return (
  <div className="songBox">
    <div className="albumImage">
      {/* //WENN UNGÜLTIGE SONGID KOMMT COVER PUREMIAS FIRST SONG ALBUM ID=ERSTE KLAMMER */}
      {(trackInfo.hasOwnProperty("error")===true) ?  (<h4><SongImage AlbumId="5Zn8yBhD95lylOMCIc5LwE"/></h4>) : (<SongImage AlbumId={trackInfo.album.id}/>)}
    </div>

    <div className="songRow__info">
      {/* //WENN UNGÜLTIGE SONGID KOMMT kein Song beim Countdown, trotzdem Rating     KLAMMER IST SMILEY*/}
      {(trackInfo.hasOwnProperty("error")===true) ?  (<p>Very quiet Artist - very Quiet song;)</p>) : (<p>{trackInfo.artists[0].name} - {trackInfo.name}</p>)}
    </div>

    {/* Rating section moved right under title */}
    <div className="songRating">
      {(showCounter===1) || (songToPlay === TrackForBox.trackid) || songsListenedTo[TrackForBox.trackid] || songsRated[TrackForBox.trackid]? (
        //TRACK ID GEBRAUCHT FUER ZAEHLER UPDATE IN SELECTION    +  SPOTIFY GEBRACUHT FUER CHEAT CHECKS
        <SongBoxCountDown trackid={TrackForBox.trackid} trackname={trackInfo.artists[0].name+"-"+trackInfo.name} spotify={spotify} songfromuser={TrackForBox.fromspotifyuser} emailreceiverrating={TrackForBox.fromSpotUserEmail} songnameemailreceiver={TrackForBox.songName}/>
      ) : (
        <div className="songRating-placeholder">&nbsp;</div>
      )}
    </div>

    {/* Play button at the bottom */}
    {songsRated[TrackForBox.trackid] ? (
      // Song has been rated, don't show play button
      <div>&nbsp;</div>
    ) : (playBlocker!==1) ? (
      // No active song or this song can be played
      <div className="playButton" onClick={playSong}>PLAY SONG</div>
    ) : (
      // There's an active song playing - check if we should show restart button for THIS song
      songToPlay === TrackForBox.trackid ? (
        // This is the currently playing song
        showRestartButton ? (
          // Show resume button during error states (all devices now use Spotify app)
          <div className="resumeButton" onClick={playSong}>
            RESUME PLAYBACK
          </div>
        ) : (
          // Normal state - let SongBoxCountDown handle the display
          <div>&nbsp;</div>
        )
      ) : (
        // Other songs during playback, show wait message or nothing based on listen status
        songsListenedTo[TrackForBox.trackid] ?
        (<div>&nbsp;</div>) :
        (<div className="waitUntil"><p>wait until current song is played and rated.</p></div>)
      )
    )}

    {/* Add to Favorites Button - HIDDEN */}
    {/* {!permanentlyAdded && (
      <div className="favoritesButtonContainer">
        <button
          className={`favoritesButton ${addedToFavorites ? 'added' : ''}`}
          onClick={addToFavorites}
          disabled={addedToFavorites}
        >
          {addedToFavorites ? '✓ Added!' : '♥ Add to my favorites'}
        </button>
      </div>
    )} */}

</div>
  )
}
export default SongBox;